import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_DEVICE_SCHEMA_LITERAL = {
    title: 'Schéma Device',
    description: 'Décrit une caisse',
    version: 13,
    keyCompression: false,
    primaryKey: 'CAISSEGID',
    type: 'object',
    properties: {
        CAISSEGID: { type: 'string', maxLength : 50 },
        CAISSE: { type: 'string' },
        C_NO: { type: 'string' },
        C_DENOMINATION: { type: 'string' },
        C_COMPTOIR_CTNUM: { type: 'string' },
        C_DO_SOUCHE: { type: ['number', 'null'] },
        C_N_ANALYTIQUE: { type: ['number', 'null'] },
        C_CA_NUM: { type: ['string', 'null'] },
        C_SUPERVISEURS_IDS: { type: ['string', 'null'] },
        C_CO_NO_MODE: { type: ['number', 'null'] },
        C_CO_NO: { type: ['number', 'null'] },
        CLU_AGENT_REQUIRED: { type: ['boolean', 'null'] },
        RUN_ONLY_ON_DEVICE: { type: ['boolean', 'null'] },
        DEVICE_ID_ALLOWED: { type: ['string', 'null'] },
        DEVICES_SUPERVISEURS: { type: ['string', 'null'] },
        SITE_SESSION: { type: 'string' },
        SITE_SESSION_ETAT: { type: 'number' },
        SESSION_TEST_ENV: { type: ['boolean', 'null'] },
        SESSION_TEST_CODE: { type: ['string', 'null'] },
        SITE_SESSION_OUVERTURE: { type: ['string', 'null'] },
        SITE_SESSION_CLOTURE: { type: ['string', 'null'] },
        CAISSE_SESSION_ETAT: { type: 'number' },
        CAISSE_SESSION_OUVERTURE: { type: ['string', 'null'] },
        CAISSE_SESSION_OUVERTURE_FH_UTC: { type: ['number', 'null'] },
        CAISSE_SESSION_CLOTURE: { type: ['string', 'null'] },
        CAISSE_SESSION_CLOTURE_FH_UTC: { type: ['number', 'null'] },
        CAISSE_SESSION: { type: 'string' },
        CAISSE_SESSION_OUVERTURE_PAR_LOCALGID: { type: ['string', 'null'] },
        CAISSE_SESSION_OUVERTURE_FOND_CAISSE: { type: 'number' },
        CAISSE_SESSION_CLOTURE_SOLDE_THEORIQUE: { type: 'number' },
        CAISSE_SESSION_CLOTURE_SOLDE_CAISSE: { type: 'number' },
        CAISSE_SESSION_CLOTURE_SOLDE_ECART: { type: 'number' },
        CAISSE_SESSION_OFFLINE_TRRSA_PK : { type: ['string', 'null'] },
        LASTSEQ_TICKET : { type: ['number', 'null'] },
        LASTSEQ_DUPLICATA : { type: ['number', 'null'] },
        CLOTURE_SOLDE_FOND_CAISSE: { type: ['number', 'null'] },
        CLOTURE_DECOMPTE_FOND_CAISSE_ITEMS : { type: ['string', 'null'] }
    },
    required: [ 'CAISSEGID', 'CAISSE', 'C_NO' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_DEVICE_SCHEMA_LITERAL);
export type RxPDeviceDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_DEVICE_SCHEMA: RxJsonSchema<RxPDeviceDocumentType> = P_DEVICE_SCHEMA_LITERAL;
